export const appName = 'TwineMedia'
export const filesRoot = '/download/'
export const thumbsRoot = '/thumbnail/'
export const apiRoot = '/api/v1/'
export const listTypes = ['Standard', 'Automatically Populated']
export const listVisibilities = ['Private', 'Public']
export const version = '1.5.0'
export const apiVersions = ['v1']